import { type SelectDataObject } from '../_tools/inputfields/Select';

const sVerwendung: (vti: boolean) => SelectDataObject[] = (vti) => [
    { i: 0, t: 'Endkunde', badge: 'Endkunde' },
    { i: 1, t: 'Wiederverkäufer', badge: 'Wiederverkäufer' },
    { i: 2, t: 'Export', badge: 'Export' },
    { i: 3, t: vti ? 'VTI' : 'Schrott', badge: vti ? 'VTI' : 'Schrott' },
    { i: 4, t: 'Auktion', badge: 'Auktion' },
    { i: 5, t: 'Bastler', badge: 'Bastler' },
];
export default sVerwendung;
